export function determineCandleTriggerTimeUnit(setupDetails) {
  return setupDetails.timeUnit;
}
